import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';

import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { HerdIcon } from 'app/agriculture/icons';
import { useProtagAnimal } from 'app/agriculture/queries/protagAnimals/useProtagAnimal';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { ShowOnMapButton } from 'app/agriculture/components/ContentBox/components/ShowOnMapButton';
import { convertMapLocationToPosition } from 'app/agriculture/components/utils/convertMapLocationToPosition';

interface ProtagAnimalDetailsComponentProps {
    protagAnimalId: string;
}

export function ProtagAnimalDetailsComponent({
    protagAnimalId,
}: ProtagAnimalDetailsComponentProps) {
    const { name } = useProtagAnimal({ protagAnimalId });
    const snapshot = useSnapshot({
        snapshotType: 'ProtagAnimal',
        parentId: protagAnimalId,
        shelfLife: { hours: 1 },
    });

    if (!snapshot) return null;

    const {
        timestamp,
        location,
        batteryVoltage,
        earTemperature,
        solarVoltage,
        ambientTemperature,
    } = snapshot;

    return (
        <ContentBox
            title={name}
            Icon={HerdIcon}
            showOnMapButton={<ShowOnMapButton position={convertMapLocationToPosition(location)} />}
        >
            <ContentBox.Section scrollable>
                <SimpleGrid columns={2}>
                    <StatDisplay
                        id="protag-timestamp"
                        name="Timestamp"
                        value={timestamp.toLocaleString()}
                    />
                    <StatDisplay
                        id="protag-battery-voltage"
                        name="Battery voltage"
                        value={batteryVoltage}
                        unit="V"
                    />
                    <StatDisplay
                        id="protag-ear-temperature"
                        name="Ear temperature"
                        value={earTemperature}
                        unit="°C"
                    />
                    <StatDisplay
                        id="protag-solar-voltage"
                        name="Solar voltage"
                        value={solarVoltage}
                        unit="V"
                    />
                    <StatDisplay
                        id="protag-ambient-temperature"
                        name="Ambient temperature"
                        value={ambientTemperature}
                        unit="°C"
                    />
                </SimpleGrid>
            </ContentBox.Section>
        </ContentBox>
    );
}
